import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../../services/user.service';
import { switchMap } from 'rxjs/operators';
import { ActiveRecordsResponse } from '../models/active-records.response';
import { ActiveRecordsFactory } from './active-records.factory';
import { environment } from 'src/environments/environment';
import type { ActiveRecordsModel } from '../models/active-records.model';

@Injectable({
  providedIn: 'root',
})
export class ActiveRecordsService {
  private readonly http = inject(HttpClient);
  private readonly userService = inject(UserService);
  private readonly activeRecordsFactory = inject(ActiveRecordsFactory);

  getActiveRecords(): Observable<ActiveRecordsModel> {
    const apiUrl = `${environment.apiUrl}/patrons/${this.userService.getUserId()}/active-records`;

    return this.http
      .get<ActiveRecordsResponse>(apiUrl)
      .pipe(switchMap((response) => from(this.activeRecordsFactory.buildActiveRecords(response))));
  }
}
